// extracted by mini-css-extract-plugin
export var closeButton = "bP_fP";
export var dialogWrapper = "bP_fQ";
export var mainContent = "bP_T";
export var modalWrapper = "bP_fN";